import { render, staticRenderFns } from "./TableCourse.vue?vue&type=template&id=38c92550&scoped=true"
import script from "./TableCourse.vue?vue&type=script&lang=js"
export * from "./TableCourse.vue?vue&type=script&lang=js"
import style0 from "./TableCourse.vue?vue&type=style&index=0&id=38c92550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c92550",
  null
  
)

export default component.exports